module.exports = "build/assets/mobileRightSmallPapers.8f76fb03.png";